import { render, staticRenderFns } from "./AccountReceivables.vue?vue&type=template&id=64e566ae&"
import script from "./AccountReceivables.vue?vue&type=script&lang=js&"
export * from "./AccountReceivables.vue?vue&type=script&lang=js&"
import style0 from "./AccountReceivables.vue?vue&type=style&index=0&id=64e566ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports